"use client";

import React, { useEffect, useState } from "react";
import makeApiCall from "@packages/lib/server-actions/rest-api";
import API_URL from "@packages/lib/server-actions/api-urls";
import { fetchAuthSession } from "aws-amplify/auth";
import { clickstreamForClicks, gaForCtaClicks, getProjectSpecificData, isPGS, isWhatuni, oldGAForCtaClicks } from "@packages/lib/utlils/commonFunction";
import { ClickstreamInterface } from "@packages/lib/utlils/clickstream";
import { ClickstreamConstants } from "@packages/shared-components/services/constants";
import ButtonLoader from "./ButtonLoader";
import { getCustomDomain } from "@packages/lib/utlils/common-function-server";

interface RequestInfoProps {
  enquiryProps: any;
  commonGAAttrs?: any;
  btnSize?: string;
  commonOldGAAttrs?:any
}

const RequestInfo = ({ enquiryProps, commonGAAttrs, btnSize = "w-full",commonOldGAAttrs }: RequestInfoProps) => {
  
  const [isLoading, setIsLoading] = useState(false);
  const [session, setSession] = useState<any>(null);
  const [url, setUrl] = useState<any>(null);
  const csData: ClickstreamInterface = {} as ClickstreamInterface;
  csData.CTATitle = ClickstreamConstants.requestInfoCTA;
  csData.actionType = ClickstreamConstants.clickAction;
  csData.eventType = "EnquiryFormClicked";
  csData.functionalityName = (
    enquiryProps?.functionalityName ||
    (enquiryProps?.sponsoredListingFlag === "Y"
      ? ClickstreamConstants.sponsorListing
      : "requestinfo")
  ).replace(/\s+/g, ""); // Remove all spaces

  useEffect(() => {
    const getSession = async () => {
      const sessionData = await fetchAuthSession({ forceRefresh: true });
      setSession(sessionData);
    };
    getSession();
  }, []);

  useEffect(() => {
    if (url) window.location.href = url;
  }, [url]);

  const handleExternalRequest = async (externalUrl: string, response: any) => {
    console.log("commonOldGAAttrs", commonOldGAAttrs)
    csData.eventType = ClickstreamConstants.requestInfoExternalEvent;
    csData.externalUrl = externalUrl;
    enquiryProps.url = externalUrl;
    enquiryProps.revenueValue = response?.webformPrice
    commonGAAttrs.click_text = csData.CTATitle
    enquiryProps.event = "email_external"
    gaForCtaClicks(enquiryProps, "request_info_external", commonGAAttrs, response.cpeFlag);
    !(isWhatuni() && commonGAAttrs.page_grouping === "scholarship_pages") && oldGAForCtaClicks(enquiryProps,"Request info",enquiryProps.url, enquiryProps.event,commonOldGAAttrs,response.cpeFlag,"")
    await clickstreamForClicks(enquiryProps, csData, commonGAAttrs);
    window.open(externalUrl, "_blank");
  };

  const buildRequestInfoUrl = (response: any) => {
    const baseUrl = `/degrees/email${enquiryProps?.collegeName ? `/${enquiryProps?.collegeName}-email` : ""}${enquiryProps?.collegeId ? `/${enquiryProps?.collegeId}` : ""}${enquiryProps?.courseId ? `/${enquiryProps?.courseId}` : "/0"}${enquiryProps?.selectedSubject ? `/${enquiryProps?.selectedSubject}` : "/0"}`;
    
    if (isPGS()) {
      return `/pgs/pgs_interactive.get_request_info_prc?${enquiryProps?.collegeId ? `z=${enquiryProps?.collegeId}` : ""}${enquiryProps?.courseId ? `&w=${enquiryProps?.courseId}` : ""}${response?.orderItemId ? `&p_order_item_id=${response?.orderItemId}` : ""}&pageName=${enquiryProps?.pageName}`;
    }

    const subOrderId = enquiryProps?.subOrderItemId ? `/n-${enquiryProps?.subOrderItemId}` : "";
    
    if (enquiryProps?.pageName === "browsemoneypageresults") {
      const sponsoredParam = enquiryProps?.sponsoredListingFlag === "Y" 
        ? `sponsoredOrderItemId=${enquiryProps?.orderItemId || "0"}` 
        : "sponsoredOrderItemId=0";
      return `${baseUrl}${subOrderId}/send-college-email.html?${sponsoredParam}&manualBoostingFlag=${enquiryProps?.manualBoostingFlag || "N"}&pageName=sr&fromPage=${enquiryProps?.pageName}`;
    }
    
    return `${baseUrl}${subOrderId}/send-college-email.html?fromPage=${enquiryProps?.pageName}`;
  };

  const getNonAdvertUrl = () => {
    if (session?.tokens?.idToken) {
      const fromType = enquiryProps?.courseId ? "COURSE" : "PROVIDER";
      return `/degrees/get-pdf?from=${fromType}&collegeId=${enquiryProps?.collegeId || ""}&courseId=${enquiryProps?.courseId || "0"}`;
    }
    
    const nonAdvertDetails = `${enquiryProps?.collegeDisplayName || ""}##${enquiryProps?.collegeId}####${enquiryProps?.courseId || "0"}#${enquiryProps?.logoUrl || ""}#${enquiryProps?.courseId ? "COURSE" : "PROVIDER"}`;
    localStorage.setItem("nonAdvertDetails", nonAdvertDetails);
    return `/register/?pagetype=non-request-info${enquiryProps?.courseName ? `&coursename=${enquiryProps?.courseName}` : ""}&collegename=${enquiryProps?.collegeName}&collegeid=${enquiryProps?.collegeId}`;
  };

  const getPGSNonAdvertUrl = () => {
    const pgsUser =
    (typeof document !== "undefined" &&
      document.cookie.split("pgs_userid=")[1]?.split(";")[0]) ||
    "0";
    const commonUrl = `/pgs/pgs_user.get_non_adv_form_prc?${enquiryProps?.collegeId ? `z=${enquiryProps?.collegeId}` : ""}${enquiryProps?.courseId ? `&w=${enquiryProps?.courseId}` : ""}`
    if(pgsUser !== "0"){
      return `${commonUrl}&p_from_type=signedpdf&pageName=${enquiryProps?.pageName}`
    }
    return `${commonUrl}&p_from_type=pdf&pageName=${enquiryProps?.pageName}`
  }

  const handleAdvertiserRequest = async () => {
    console.log("commonOldGAAttrs", commonOldGAAttrs)
    commonGAAttrs.study_mode = enquiryProps?.studyMode || "NA";
    if (sessionStorage.getItem("veppleProviders")) {
      commonGAAttrs.data_label5 = "vepple_driven";
    }

    const response = await makeApiCall({
      url: `${process.env.NEXT_PUBLIC_DOMSERVICE_API_DOMAIN}/${API_URL?.getEnquiryDetails}`,
      method: "POST",
      body: {
        suborderItemId: enquiryProps?.subOrderItemId,
        orderItemId: enquiryProps?.orderItemId,
        collegeId: enquiryProps?.collegeId,
        courseId: enquiryProps?.courseId,
        affiliateId: getProjectSpecificData("affiliateId"),
        qualCode: enquiryProps?.qualCode,
      },
      headers: { "x-api-key": `${process.env.NEXT_PUBLIC_DOMSERVICE_X_API_KEY}` },
    });

    const externalUrl = response?.stdRequestInfoUrl || response?.requestInfoWebform;
    
    if (externalUrl) {
      await handleExternalRequest(externalUrl, response);
    } else if (response?.requestInfoEmail) {
      csData.eventType = ClickstreamConstants.requestInfoInternalEvent;
      const requestUrl = buildRequestInfoUrl(response);
      enquiryProps.revenueValue = response?.emailPrice
      enquiryProps.url = getCustomDomain() + requestUrl;
      commonGAAttrs.click_text = csData.CTATitle
      enquiryProps.event = "request info"
      gaForCtaClicks(enquiryProps, "request_info_internal", commonGAAttrs, response.cpeFlag);
      !(isWhatuni() && commonGAAttrs.page_grouping === "scholarship_pages") && oldGAForCtaClicks(enquiryProps,"Request info",enquiryProps.url,"email_request",commonOldGAAttrs,response.cpeFlag,"")
      await clickstreamForClicks(enquiryProps, csData, commonGAAttrs);
      setUrl(requestUrl);
    }
  };

  const handleNonAdvertiserRequest = async () => {
    const requestUrl = isPGS() 
      ? getPGSNonAdvertUrl()
      : getNonAdvertUrl();
    
    enquiryProps.url = requestUrl;
    commonGAAttrs.click_text = csData.CTATitle
    gaForCtaClicks(enquiryProps, "request_info_internal", commonGAAttrs, "");
    csData.eventType = ClickstreamConstants.requestInfoInternalEvent;
    await clickstreamForClicks(enquiryProps, csData, commonGAAttrs);
    setUrl(requestUrl);
  };

  const handleRequestInfo = async () => {
    setIsLoading(true);
    try {
      const isAdvertiser = enquiryProps?.subOrderItemId || enquiryProps?.sponsoredListingFlag === "Y";
      
      if (isAdvertiser) {
        await handleAdvertiserRequest();
      } else {
        await handleNonAdvertiserRequest();
      }
    } catch (error) {
      console.error("Error fetching enquiry data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      type="button"
      className={`btn btn-blue flex justify-center items-center ${btnSize} ${enquiryProps?.hasRequiredFlags ? "justify-self-end lg:w-[162px]" : ""}`}
      onClick={handleRequestInfo}
    >
      <ButtonLoader isLoading={isLoading}>
        {ClickstreamConstants.requestInfoCTA}
      </ButtonLoader>
    </button>
  );
};

export default RequestInfo;
